import React, {FC} from 'react';

import {Skeleton} from '@optimaxdev/design-system';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {HostApplicationStoreType} from 'hostApplicationStoreType';

import s from './skeleton.scss';

const ItemsSkeleton: FC<{styles: {[key: string]: number | string}}> = ({styles}) => {
    return (
        <div className={s.productsSkeletonContainer} style={{...styles}}>
            <Skeleton className={s.pickSkeleton} />
            <div className={s.itemSkeletonContainer}>
                <Skeleton className={s.itemTextSkeleton} width={115} />
                <Skeleton className={s.itemTextSkeleton} width={73} />
                <Skeleton className={s.itemTextSkeleton} width={74} />
                <Skeleton className={s.itemTextSkeleton} width={152} />
            </div>
        </div>
    );
};

type PropsType = {isLoggedIn: boolean};
const getCartItemsCount = (store: HostApplicationStoreType) => store.cart.count;

/**
 *  mini cart body skeleton
 */
export const MiniCartSkeleton: FC<PropsType> = ({isLoggedIn}) => {
    const cartItemsCount = useHostSelector(getCartItemsCount);

    return (
        <div aria-label="Mini cart is loading" className={s.skeletonContainer}>
            {isLoggedIn && (
                <div data-testid="login-skeleton">
                    <Skeleton className={s.loginSkeleton} data-testid="login-skeleton" />
                </div>
            )}
            <div className={s.bodySkeleton}>
                {[...Array(cartItemsCount).keys()].map((key, index) => (
                    <ItemsSkeleton
                        styles={{
                            borderBottom:
                                index === cartItemsCount - 1 ? 'none' : '1px solid #F1F3F4',
                            marginBottom: 28,
                            paddingBottom: 28,
                        }}
                        key={key}
                    />
                ))}
            </div>
            <div className={s.footerSkeleton}>
                <div className={s.footerTopPart}>
                    <Skeleton className={s.footerTextSkeleton} />
                    <Skeleton className={s.footerTextSkeleton} />
                    <Skeleton className={s.footerTextSkeleton} />
                    <Skeleton className={s.footerTextSkeleton} />
                </div>
                <div className={s.footerBottomPart}>
                    <Skeleton className={s.footerBigTextSkeleton} />
                    <Skeleton className={s.footerTextSkeleton} />
                </div>
            </div>
        </div>
    );
};
